import {PropertyRegime} from "../enums/propertyRegime.enum";
import {AccountType} from "../enums/accountType.enum";

export class DataPersonalSellerPf {
  name: string;
  documentNumber?: string;
  birth: Birth;
  gender: string;
  profession: string;
  hasDeclaration: boolean;
  relationship: Relationship;
  document: Document;
  parentage: Parentage;
  contact: Contact;
  address: Address;
  deliveryAddress?: Address;
  attorneyData?: AttorneyData;
  additionalInformation: AdditionalInformation;
  payment: Payment;
  partner?: Partner;
  [key: string]: any;

  constructor() {
    this.relationship = new Relationship();
    this.document = new Document();
    this.parentage = new Parentage();
    this.contact = new Contact();
    this.address = new Address();
    this.additionalInformation = new AdditionalInformation();
    this.payment = new Payment();
  }
}

export class Partner {
  name: string;
  cpf: string;
  gender: string;
  profession: string;
  birth: Birth;
  document: Document;
  parentage: Parentage;
  contact: Contact;
  address: Address;
  deliveryAddress?: Address;
  attorneyData?: AttorneyData;
  additionalInformation: AdditionalInformation;
  payment?: Payment;
}

export class Birth {
  date: string;
  state?: string;
  city: string;
  nationality: string;
}

export class Relationship {
  maritalStatus: string;
  hasStableUnion: boolean;
  hasPartInSale: boolean;
  marriageDate: string;
  propertyRegime: PropertyRegime;
}

export class Document {
  type: string;
  number: string;
  issueDate: string;
  issuingAuthority: string;
  issuingAuthorityState: string;
}

export class Parentage {
  motherName: string;
  fatherName?: string;
}

export class Contact {
  email: string;
  phone: string;
}

export class Address {
  isLocale?: boolean;
  zipCode: string;
  street: string;
  number: string;
  complement: string;
  district: string;
  city: string;
  state: string;
}

export class AttorneyData {
  useAttorney?: boolean;
  fullName: string;
  documentNumber: string;
  email: string;
  phone: string;
}

export class AdditionalInformation {
  hasEmployee: boolean;
  isSellingToFamily: boolean;
  isUnderAge: boolean;
  situation: string;
}

export class Payment {
  accountType: AccountType;
  bankNumber: string;
  agencyNumber: string;
  accountNumber: string;
  accountDigit?: string;
}
